// extracted by mini-css-extract-plugin
export default {"container":"AssetCell_container__ICUYO","image":"AssetCell_image__aOUXO"};